"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const fs = __importStar(require("fs"));
const util_1 = __importDefault(require("util"));
const os_1 = __importDefault(require("os"));
const path_1 = __importDefault(require("path"));
const util_2 = require("./util");
function getSubcratesFolder(seratoFolder = "") {
    return path_1.default.join(seratoFolder, "SubCrates");
}
// Singleton for Serato Folder Path (I doubt it'll change during runtime)
const PLATFORM_DEFAULT_SERATO_FOLDER = path_1.default.join(os_1.default.homedir(), "Music", "_Serato_");
/**
 * @class Crate
 */
class Crate {
    /**
     * Serato saves crates in all the drives from which songs
     * in the crate come from. When you create a seratojs.Crate
     * it assumes we are dealing with a Music-folder-main-drive crate.
     *
     * You can "fix" this crate to represent a particular crate in
     * one particular Serato folder; in which case saving will use
     * that location only. You are responsible for adding songs
     * compatible with that drive. This is what we call 'location-aware'
     * crates.
     */
    constructor(name, seratoFolder) {
        // TODO: Make private
        this.name = (0, util_2.sanitizeFilename)(name);
        this.filename = this.name + ".crate";
        this.songPaths = [];
        this.seratoFolder = seratoFolder; // To override for testing...
    }
    getData() {
        this.saveLocations = this.getSaveLocations();
        this.songPaths = this.getSongPathsSync();
        return this;
    }
    /**
     * Returns the Serato directories where this will be saved.
     */
    getSaveLocations() {
        if (this.seratoFolder) {
            return [this.seratoFolder]; // if specified at construction use this only.
        }
        if (this.songPaths.length === 0) {
            return [PLATFORM_DEFAULT_SERATO_FOLDER];
        }
        const roots = new Set();
        this.songPaths.forEach((songPath) => {
            if ((0, util_2.isFromExternalDrive)(songPath)) {
                const externalRoot = (0, util_2.selectExternalRoot)(songPath);
                roots.add(path_1.default.join(externalRoot, "_Serato_"));
            }
            else {
                roots.add(PLATFORM_DEFAULT_SERATO_FOLDER);
            }
        });
        return Array.from(roots);
    }
    // TODO: When reading, where should it read from?
    getSongPaths() {
        return __awaiter(this, void 0, void 0, function* () {
            const filepath = this._buildCrateFilepath(this.seratoFolder || PLATFORM_DEFAULT_SERATO_FOLDER);
            const contents = yield util_1.default.promisify(fs.readFile)(filepath, "ascii");
            return (0, util_2.parse)(contents);
        });
    }
    getSongPathsSync() {
        const filepath = this._buildCrateFilepath(this.seratoFolder || PLATFORM_DEFAULT_SERATO_FOLDER);
        const contents = fs.readFileSync(filepath, "ascii");
        return (0, util_2.parse)(contents);
    }
    addSong(songPath) {
        if (this.songPaths === null) {
            this.songPaths = [];
        }
        const resolved = path_1.default.resolve(songPath);
        this.songPaths.push(resolved);
    }
    _buildCrateFilepath(seratoFolder) {
        const subcrateFolder = getSubcratesFolder(seratoFolder);
        const filepath = path_1.default.join(subcrateFolder, this.filename);
        return filepath;
    }
    _buildSaveBuffer() {
        const header = "vrsn   8 1 . 0 / S e r a t o   S c r a t c h L i v e   C r a t e".replace(/ /g, "\0");
        let playlistSection = "";
        if (this.songPaths) {
            this.songPaths.forEach((songPath) => {
                const absoluteSongPath = path_1.default.resolve(songPath);
                const songPathWithoutDrive = (0, util_2.removeDriveRoot)(absoluteSongPath);
                const data = (0, util_2.toSeratoString)(songPathWithoutDrive);
                let ptrkSize = (0, util_2.intToHexbin)(data.length);
                let otrkSize = (0, util_2.intToHexbin)(data.length + 8); // fixing the +8 (4 for 'ptrk', 4 for ptrkSize)
                playlistSection += "otrk" + otrkSize + "ptrk" + ptrkSize + data;
            });
        }
        const contents = header + playlistSection;
        return Buffer.from(contents, "ascii");
    }
    save() {
        return __awaiter(this, void 0, void 0, function* () {
            for (const seratoFolder of this.getSaveLocations()) {
                const filepath = this._buildCrateFilepath(seratoFolder);
                const buffer = this._buildSaveBuffer();
                return util_1.default.promisify(fs.writeFile)(filepath, buffer, {
                    encoding: null,
                });
            }
        });
    }
    saveSync() {
        for (const seratoFolder of this.getSaveLocations()) {
            const filepath = this._buildCrateFilepath(seratoFolder);
            const buffer = this._buildSaveBuffer();
            // Ensure folder exists
            fs.writeFileSync(filepath, buffer, { encoding: null });
        }
    }
}
exports.default = Crate;
//# sourceMappingURL=Crate.js.map